import * as tslib_1 from "tslib";
import { QueryEntity } from '@datorama/akita';
import { NotificationsStore } from './notifications.store';
import * as i0 from "@angular/core";
import * as i1 from "./notifications.store";
var NotificationsQuery = /** @class */ (function (_super) {
    tslib_1.__extends(NotificationsQuery, _super);
    function NotificationsQuery(store) {
        var _this = _super.call(this, store) || this;
        _this.store = store;
        _this.notifications$ = _this.selectAll();
        _this.planningSelectedDate$ = _this.select(function (state) { return state.planningSelectedDate; });
        _this.loading$ = _this.selectLoading();
        return _this;
    }
    NotificationsQuery.ngInjectableDef = i0.defineInjectable({ factory: function NotificationsQuery_Factory() { return new NotificationsQuery(i0.inject(i1.NotificationsStore)); }, token: NotificationsQuery, providedIn: "root" });
    return NotificationsQuery;
}(QueryEntity));
export { NotificationsQuery };
